<script setup>

</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19.23,4h-14a2,2,0,0,0-2,2V18a2,2,0,0,0,2,2h14a2,2,0,0,0,2-2V6A2,2,0,0,0,19.23,4Zm0,14H12V15.75a2,2,0,0,0-2-2H5.23V6h14Z"></path></svg>
</template>
